import React from "react";
import LandingTemplate from "@/components/LandingTemplate";
import usePageMeta from "@/lib/usePageMeta";

export default function Energiforbedring() {
  usePageMeta({
    title: "Energiforbedring med nye vinduer og døre",
    description:
      "Lavere varmeregning, bedre indeklima og slut med træk. Nye vinduer og døre fra Hagelund — book et uforpligtende inspirationsmøde.",
    path: "/lp/energiforbedring",
  });

  return (
    <LandingTemplate
      testId="landing-energi"
      page="Energiforbedring"
      eyebrow="Energiforbedring"
      titleLines={["Lavere varme-", "regning. Bedre", "indeklima."]}
      valueProp="Nye vinduer og døre med 3-lags energiglas holder på varmen, fjerner kuldebroer og giver et mærkbart bedre indeklima — året rundt."
      points={[
        "Op til markant lavere energiforbrug",
        "Slut med træk og kolde overflader",
        "Bedre lyddæmpning og komfort",
        "Rådgivning ud fra netop dit hus",
      ]}
      image="/images/christiansminde-6.webp"
      gallery={["/images/christiansminde-5.webp", "/images/skovvej-8.webp", "/images/christiansminde-2.webp"]}
    />
  );
}
